import React, { useState } from "react"

import { noop } from "lodash"
import ReactCountryFlag from "react-country-flag"
import { textToTitleCase } from "utils/helpers"

const CreatorCard: React.FC<{ creator: any }> = ({ creator }) => {


    return (
        <React.Fragment>
            <div className="application-card cursor-pointer" onClick={noop}>
                <div className={`d-flex gap-3 p-2 justify-content-between influencer-profile-header`}>
                    <div className={`d-flex gap-3 w-100`}>
                        {/* <div className="position-relative">
                            <img src={igPP} className="inf-profile-pic border-none" style={{border: 'none'}}/>
                            <div className="ig-logo-space" style={{bottom: '5px', right: '5px'}}>
                                <div className="ig-logo"></div>
                            </div>
                        </div> */}
                        <div className="d-flex flex-column gap-1 justify-content-center w-100 overflow-hidden">
                            <span className="inf-name text-truncate w-100" style={{fontWeight: '600', fontSize: '14px'}}>@{creator.username}</span>
                            <div className="d-flex align-items-center gap-2">
                                {
                                    creator.country &&
                                    <span className="badge language-badge"><ReactCountryFlag countryCode={creator.country} className="me-1" />  {creator.country}</span>
                                }
                                {
                                    creator.gender &&
                                    <span className="badge language-badge">{creator.gender === 'male' ? <span className="mdi mdi-gender-male me-1"></span> : (creator.gender === 'female' ? <span className="mdi mdi-gender-female me-1"></span> : '') } {textToTitleCase(creator.gender ?? '')}</span>
                                }
                                {
                                    creator.age_bucket &&
                                    <span className="badge language-badge"><span className="mdi mdi-cake me-1"></span> {creator.age_bucket}</span>
                                }

                                </div>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <p className="p-3" style={{overflowWrap: 'break-word'}}>{creator.biography}</p>
                <div className="divider"></div>
                <div className="p-3 d-flex align-items-center">
                    <strong><span className="mdi mdi-email me-2 fs-5 text-primary"></span></strong> <span>{creator.email}</span>
                </div>
            </div>
        </React.Fragment >

    )
}

export default CreatorCard